import * as React from 'react';

export interface AvatarProps {
  readonly name: string;
  readonly title?: string;
}

/**
 * Iniciály do kolečka. Krok UXR3: JEDEN vypocet pro vsechna tri mista, kde
 * se kreslí — karta kanbanu (Avatar niz), avatar prihlaseneho uzivatele
 * (`layout.tsx`) a makler v hlavicce zakazky (`zakazka-detail.tsx`).
 * `fallback` pouziva layout, kdyz uzivatel nema jmeno (bere prvni dva znaky
 * e-mailu); bez nej je vysledek „?".
 */
export function initials(name: string, fallback = ''): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  const value = (first + last).toUpperCase();
  if (value !== '') return value;
  return fallback !== '' ? fallback.slice(0, 2).toUpperCase() : '?';
}

/** Kolegovo jmeno jako iniciály v kolecku - kanban karta (R4), nahrazuje chybejici foto. */
export function Avatar({ name, title }: AvatarProps): React.JSX.Element {
  /*
   * `role="img"`: na `<span>` bez role je `aria-label` zakazany atribut
   * (axe `aria-prohibited-attr`) a ctecka by jmeno kolegy zahodila — tentyz
   * nalez jako u nahledu bez fotky v `routes/nemovitosti.tsx`.
   */
  return (
    <span role="img" className="rh-avatar" title={title ?? name} aria-label={name}>
      {initials(name)}
    </span>
  );
}
